module.exports = __webpack_public_path__ + "2e05b994c8a8a31507b6f9c4a1ab3888.png";